<div class="mi-perfil-container">
  <div class="page-header">
    <h1><i class="fas fa-user"></i> Mi Perfil</h1>
    <button class="btn btn-outline-primary" (click)="refreshProfile()" [disabled]="loading">
      <i class="fas" [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-sync-alt'"></i>
      {{ loading ? 'Actualizando...' : 'Actualizar' }}
    </button>
  </div>

  <div class="content">
    <!-- Loading State -->
    <div *ngIf="loading && !currentUser" class="loading-container">
      <div class="spinner">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <p>Cargando perfil...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="alert alert-danger">
      <i class="fas fa-exclamation-circle"></i>
      {{ error }}
      <button class="btn btn-sm btn-danger" (click)="loadProfile()">
        Reintentar
      </button>
    </div>

    <!-- User Profile -->
    <div *ngIf="currentUser && !loading">
      <app-usuario-card 
        [user]="currentUser"
        (viewDetail)="onViewEstudianteDetail($event)">
      </app-usuario-card>
    </div>
  </div>

  <!-- Modal para detalle de estudiante -->
  <div class="modal-overlay" *ngIf="showDetail" (click)="onCloseDetail()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="modal-close" (click)="onCloseDetail()">
        <i class="fas fa-times"></i>
      </button>
      <app-estudiante-detail 
        [estudiante]="selectedEstudiante"
        (cancelEdit)="onCloseDetail()">
      </app-estudiante-detail>
    </div>
  </div>
</div>